<template lang="pug">
  div
    v-card.my-4(flat style="border:1px solid var(--v-basic400);")
      .header.px-4
        template(v-if="hoursHeader")
          div.s1.mt-4 {{ $t('hours') }}
          div.c1.basic600--text {{ $t('hours_text') }}
        v-row.py-4(no-gutters align='center')
          v-col
            .p2.basic700--text {{ $t('use_same_hours') }}
          v-col.shrink
            y-switch.mb-n2(v-model="hours.use_same_hours" :color="$vuetify.theme.themes[$theme].success400")
      
      v-divider.basic300
      .enable(v-if="!hours.use_same_hours")
        v-tabs(v-model="hoursType" color="textColorAccent" :height="40" grow)
          v-tab.button-AA-medium {{ $t('delivery') }}
          v-tab.button-AA-medium.mx-n3 {{ $t('pick_up') }}
        v-divider.basic300
      
      div(v-for="key in ['delivery_hours', 'pickup_hours']" :key="key")
        .hours.px-4.my-4(v-if="hoursTypeValue == key" v-for="(key_hour, parentIndex) in hours[key]" :key="JSON.stringify(key_hour.days)")
          v-divider.basic300.mb-4(v-if="parentIndex != 0")
          div.d-flex
            eva-icon.mr-1(name="calendar-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="20" height="20")
            .label.basic600--text.text-uppercase.mt-1 {{ $t('days') }}
          v-row.mt-2(no-gutters)
            v-col.shrink(v-for="day in hourDays" :key="day.name + '-' + parentIndex")
              v-btn.mr-2.mb-2(v-if="key_hour.days.includes(day.name)" color="textColorAccent" depressed height=32 @click='toggleDay(key_hour, day, availableDays(hours[key]))')
                .button-AA-small.basic100--text {{ day.display }}
              v-btn.mr-2.mb-2(v-else color="textColorHint" depressed outlined height=32 @click='toggleDay(key_hour, day, availableDays(hours[key]))')
                .button-AA-small.textColorHint--text {{ day.display }}
                          
          div.d-flex.mt-2
            eva-icon.mr-1(name="clock-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="20" height="20" style="margin-top:1px")
            .label.basic600--text.text-uppercase.mt-1 {{ $t('hours') }}

          template(v-for="(slot, index) in key_hour.data.hours")
            v-row.mt-2(no-gutters :key="JSON.stringify(slot)" align="center")
              v-col.pr-2
                v-dialog(ref='dialog' v-model='slot.begin_show' width='290px')
                  template(v-slot:activator='{ on, attrs }')
                    v-text-field(v-model="slot.begin_time" placeholder="Begin hour" background-color="basic200" height="40" outlined dense hide-details readonly :rules="rules.not_empty" v-bind='attrs' v-on='on' @click="slot.begin_picker = slot.begin")
                  v-time-picker(v-model="slot.begin_picker" :max="slot.end" color="info500")
                    v-btn(@click="saveTime(slot, 'begin')" color="info500" dark depressed small block)
                      .button-AA-small.basic100--text set
              v-col.shrink.px-2
                div to
              v-col.px-2
                v-dialog(ref='dialog' v-model='slot.end_show' width='290px')
                  template(v-slot:activator='{ on, attrs }')
                    v-text-field(v-model="slot.end_time" placeholder="End hour" background-color="basic200" height="40" outlined dense hide-details readonly :rules="rules.not_empty" v-bind='attrs' v-on='on' @click="slot.end_picker = slot.end")
                  v-time-picker(v-model="slot.end_picker" :min="slot.begin" color="info500")
                    v-btn(@click="saveTime(slot, 'end')" color="info500" dark depressed small block)
                      .button-AA-small.basic100--text set
              v-col.shrink.clickable
                eva-icon(v-if="key_hour.data.hours[index + 1]" name="close-circle-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="18" height="18" style="margin-top: 3px" @click="key_hour.data.hours.splice(index + 1, 1)")
                eva-icon(v-else name="plus-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" width="18" height="18" style="margin-top: 3px" @click="clickAddNewSlot(key_hour, slot)")

          y-checkbox.my-auto.mx-0.pa-0.mt-6(v-model="key_hour.data.order_limit_enabled")
            template(v-slot:label)
              div.p2.my-auto {{ $t('limit_number_delivery') }}

          .enable(v-if="key_hour.data.order_limit_enabled")
            .mb-1.label.basic600--text.text-uppercase.mt-2 {{ $t('order_limit') }}
            v-text-field.my-2(v-model="key_hour.data.order_limit" background-color="basic200" height="40" outlined dense placeholder="0" type="number" :rules="rules.has_quantity" hide-details="auto")

          .add-hour-set.mx-n4(v-if="availableDays(hours[key]).length > 0 && parentIndex == hours[key].length - 1")
            v-divider.basic300.mt-4
            v-btn.px-0.mb-n4.mx-4(color="textColorAccent" text @click="clickAddNewHourSet(hours[key])")
              eva-icon.mr-1(name="plus-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" width="16" height="16" style="margin-top: 3px")
              span.button-Aa-small.textColorAccent--text {{ $t('add_hours_for_other') }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'BusinessHours',
  components: { },
  props: ['parentHours', 'hoursHeader'],
  data: () => ({
    hoursType: 0,
    hoursTypeValue: 'delivery_hours',
    hourDays: [
      { name: 'Monday', display: 'mon' },
      { name: 'Tuesday', display: 'tue' },
      { name: 'Wednesday', display: 'wed' },
      { name: 'Thursday', display: 'thu' },
      { name: 'Friday', display: 'fri' },
      { name: 'Saturday', display: 'sat' },
      { name: 'Sunday', display: 'sun' }
    ],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required'],
      instructions_count: [v => v.length <= 300 || 'Max 300 characters']
    }
  }),
  computed: {
    hours: {
      get () {
        return this.parentHours
      },
      set (newValue) {
        this.$emit('update:parentHours', newValue)
      }
    },
  },
  watch: {
    hoursType (val) {
      if (val === 0) {
        this.hoursTypeValue = 'delivery_hours'
      } else {
        this.hoursTypeValue = 'pickup_hours'
      }
    },
    'hours.use_same_hours' (val) {
      if (val) {
        this.hoursTypeValue = 'delivery_hours'
      }
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    availableDays (hours) {
      let list = this.hourDays
      hours.forEach(hour => {
        hour.days.forEach(day => {
          list = list.filter(f => f.name !== day)
        })
      })
      return list
    },
    clickAddNewHourSet (hours) {
      const data = {
        data: { hours: [{ begin: null, begin_time: null, end: null, end_time: null }], order_limit_enabled: false, order_limit: null},
        days: this.availableDays(hours).map(m => { return m.name })
      }
      hours.push(data)
    },
    saveTime (slot, key) {
      if (key === 'begin') {
        slot.begin = slot.begin_picker
        slot.begin_time = this.formatTime(slot.begin)
        delete slot.begin_show
        delete slot.begin_picker
      } else {
        slot.end = slot.end_picker
        slot.end_time = this.formatTime(slot.end)
        delete slot.end_show
        delete slot.end_picker
      }
    },
    formatTime (time24) {
      let ts = time24
      const H = + ts.substr(0, 2)
      let h = (H % 12) || 12
      h = (h < 10) ? ('0' + h) : h
      const ampm = H < 12 ? 'am' : 'pm'
      ts = h + ':' + ts.substr(3, 2) + ampm
      return ts
    },
    toggleDay (hours, day, available) {
      if (hours.days.includes(day.name)) {
        hours.days = hours.days.filter(f => f !== day.name)
      } else {
        if (available.includes(day)) {
          hours.days.push(day.name)
        }
      }
    },
    clickAddNewSlot (hours, slot) {
      hours.data.hours.push({ begin: slot.end, begin_time: this.formatTime(slot.end), end: null, end_time: null })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "hours": "Hours",
    "hours_text": "Set hours when orders for pickup and delivery will be fulfilled.",
    "use_same_hours": "Use same hours for pickup & delivery",
    "delivery": "Delivery",
    "days": "Days",
    "limit_number_delivery": "Limit number of delivery orders per day",
    "order_limit": "Order Limit",
    "add_hours_for_other": "Add hours for other days"
  },
  "id": {
    "hours": "Jam",
    "hours_text": "Tetapkan jam kapan pesanan untuk pengambilan dan pengiriman akan dipenuhi.",
    "use_same_hours": "Gunakan waktu yang sama untuk pengambilan & pengiriman",
    "delivery": "Pengiriman",
    "days": "Hari",
    "limit_number_delivery": "Batasi jumlah pesanan pengiriman per hari",
    "order_limit": "Batas pesanan",
    "add_hours_for_other": "Tambahkan jam untuk hari lain"
  }
}
</i18n>
